<template>
	<view class="box">
		<view class="box_item">
			<view class="box_item_shop">
				<image src="@/static/uni.png" mode="widthFix"></image>
				<view class="box_item_shop_right">
					<text class="a">清澄白河马克杯-节日版定制</text>
					<view class="boxs">
						<uni-rate size="18" :value="5" color="#bbb" active-color="red" />
						<text class="b">非常好</text>
					</view>
				</view>
			</view>
			<view class="review_appraise_bottom">
				<textarea placeholder="描述商品和使用感受，更受欢迎哦～">
				</textarea>
				<view class="review_appraise_bottom_list">
					<view class="review_appraise_bottom_list_item">
						<image src="@/static/icon/ic_upload@2x.png" mode="widthFix"></image>
					</view>
				</view>
			</view>
		</view>
		<view class="box_item">
			<view class="box_item_shop">
				<image src="@/static/uni.png" mode="widthFix"></image>
				<view class="box_item_shop_right">
					<text>清澄白河马克杯-节日版定制</text>
					<view class="boxs">
						<uni-rate size="18" :value="5" color="#bbb" active-color="red" />
						<text class="b">非常好</text>
					</view>
				</view>
			</view>
			<view class="review_appraise_bottom">
				<textarea placeholder="描述商品和使用感受，更受欢迎哦～">
				</textarea>
				<view class="review_appraise_bottom_list">
					<view class="review_appraise_bottom_list_item">
						<image src="@/static/icon/ic_upload@2x.png" mode="widthFix"></image>
					</view>
				</view>
			</view>
		</view>
		<view class="box_pj">
			<view class="box_pj_head">
				<text>物流服务评价</text>
				<text>满意请给5星哦</text>
			</view>
			<view class="box_pj_list">
				<view class="box_pj_list_item">
					<text class="box_pj_list_item_label">快递包装</text>
					<uni-rate size="18" :value="5" color="#bbb" active-color="red" />
					<text class="box_pj_list_item_fen">好</text>
				</view>
				<view class="box_pj_list_item">
					<text class="box_pj_list_item_label">送货速度</text>
					<uni-rate size="18" :value="5" color="#bbb" active-color="red" />
					<text class="box_pj_list_item_fen">好</text>
				</view>
			</view>
		</view>
		<view class="box_footer">
			<view class="box_footer_btn">提交评价</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_item {
			display: flex;
			flex-direction: column;
			padding: 28rpx 32rpx;
			background-color: #fff;
			box-sizing: border-box;
			.box_item_shop {
				display: flex;
				align-items: center;
				image {
					width: 108rpx;
					height: 108rpx;
					border-radius: 10rpx;
					flex-shrink: 0;
					margin-right: 20rpx;
				}
				.box_item_shop_right {
					flex: 1;
					height: 108rpx;
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					text {
						font-size: 32rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
					}
					.boxs {
						display: flex;
						align-items: center;
						.b {
							font-size: 24rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #CCCCCC;
							margin-left: 24rpx;
						}
					}
				}
			}
			.review_appraise_bottom {
				width: 100%;
				background: #F5F5F5;
				border-radius: 12rpx;
				margin-top: 28rpx;
				padding: 30rpx 24rpx;
				box-sizing: border-box;
				textarea {
					width: 100%;
					height: 100rpx;
				}
				.review_appraise_bottom_list {
					margin-top: 50rpx;
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					.review_appraise_bottom_list_item {
						width: 172rpx;
						height: 172rpx;
						margin-right: 30rpx;
						image {
							width: 100%;
							height: 100%;
						}
					}
				}
			}
		}
		.box_pj {
			width: 100%;
			padding: 28rpx 32rpx;
			background-color: #fff;
			box-sizing: border-box;
			margin-top: 16rpx;
			.box_pj_head {
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					&:nth-child(1) {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					&:nth-child(2) {
						font-size: 24rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #999999;
					}
				}
			}
			.box_pj_list {
				width: 100%;
				display: flex;
				flex-direction: column;
				margin-top: 56rpx;
				.box_pj_list_item {
					display: flex;
					align-items: center;
					margin-bottom: 34rpx;
					&:last-child {
						margin-bottom: 0 !important;
					}
					.box_pj_list_item_label {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
						margin-right: 30rpx;
					}
					.box_pj_list_item_fen {
						font-size: 24rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #CCCCCC;
						margin-left: 24rpx;
					}
				}
			}
		}
		.box_footer {
			width: 100%;
			padding: 0 56rpx;
			box-sizing: border-box;
			margin-top: 60rpx;
			padding-bottom: calc(20rpx + env(safe-area-inset-bottom));
			.box_footer_btn {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
			}
		}
	}
</style>